import {IApiActionResult} from "src/~api/ApiActionResult";
import {IChannel} from "../~store/models/Channel";
import {IQrCodeResult} from "../~store/models/QrCodeResult";
import {fetchGet, getApiActionResult, fetchPost} from "src/~api/ApiHelper";
import {
    GET_CHANNELS_API_ROUTE,
    SAVE_CHANNEL_API_ROUTE,
    DELETE_CHANNEL_API_ROUTE,
    SAVE_CHANNEL_SETTING_API_ROUTE,
    GET_SETTING_BY_CHANNEL_ID_API_ROUTE,
    GET_CHANNEL_BY_ID_API_ROUTE,
    GET_CHANNELS_BY_CHANNELSID_API_ROUTE,
    GET_SETTINGS_BY_CHANNELS_ID_API_ROUTE,
    RESTART_CHANNEL_API_ROUTE,
    GET_CHANNEL_CONTACTS_COUNT_API_ROUTE,
    GET_CHANNEL_QR_CODE_API_ROUTE,
    IMPORT_CHANNEL_OPERATORS_API_ROUTE
} from "./apiRoutes";
import { ISetting } from "src/app/setting/~store/models/setting";

export const getAllChannelsAsync = async (): Promise<IApiActionResult<IChannel[]>> => {
    const fetchPromise = fetchGet(GET_CHANNELS_API_ROUTE);
    return await getApiActionResult(fetchPromise, true);
};

export const getChannelByIdAsync = async (channelId: number): Promise<IApiActionResult<IChannel>> => {
    const fetchPromise = fetchGet(GET_CHANNEL_BY_ID_API_ROUTE + channelId);
    return await getApiActionResult(fetchPromise, true);
}

export const getChannelContactsCountByChannelIdAsync = async (channelId: number): Promise<IApiActionResult<number>> => {
    const fetchPromise = fetchGet(GET_CHANNEL_CONTACTS_COUNT_API_ROUTE + channelId);
    return await getApiActionResult(fetchPromise, true);
}

export const saveChannelAsync = async (newChannel: IChannel): Promise<IApiActionResult<IChannel>> => {
    const fetchPromise = fetchPost(SAVE_CHANNEL_API_ROUTE, {
        body: JSON.stringify({data: newChannel})
    });
    return await getApiActionResult(fetchPromise, true);
};

export const deleteChannelAsync = async (channel: IChannel): Promise<IApiActionResult<Number>> => {
    const fetchPromise = fetchPost(DELETE_CHANNEL_API_ROUTE + channel.channelId, {});
    return await getApiActionResult(fetchPromise, true);
};

export const restartChannelAsync = async (channel: IChannel): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(RESTART_CHANNEL_API_ROUTE + channel.channelId, {});
    return await getApiActionResult(fetchPromise, false);
}

export const saveChannelSettingAsync = async (channelId: number, setting: string): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(SAVE_CHANNEL_SETTING_API_ROUTE, {
        body: JSON.stringify({
            channelId,
            data: {
                value: setting
            }
        })
    });
    return await getApiActionResult(fetchPromise, false);
};

export const getSettingByChannelIdAsync = async (channelId: number): Promise<IApiActionResult<ISetting>> => {
    const fetchPromise = fetchGet(GET_SETTING_BY_CHANNEL_ID_API_ROUTE + channelId);
    return await getApiActionResult(fetchPromise, true);
};

export const getSettingsByChannelsIdAsync = async (channelsId: number[]): Promise<IApiActionResult<ISetting[]>> => {
    const fetchPromise = fetchPost(GET_SETTINGS_BY_CHANNELS_ID_API_ROUTE, {
        body: JSON.stringify({channelsId})
    });
    return await getApiActionResult(fetchPromise, true);
};

export const getChannelsByChannelsIdAsync = async (channelsId: number[]): Promise<IApiActionResult<IChannel[]>> => {
    const fetchPromise = fetchPost(GET_CHANNELS_BY_CHANNELSID_API_ROUTE, {
        body: JSON.stringify(
            channelsId
        )
    });
    return await getApiActionResult(fetchPromise, true);
};

export const getTelegramQrCodeAsync = async (channelId: number): Promise<IApiActionResult<IQrCodeResult>> => {
    const fetchPromise = fetchGet(GET_CHANNEL_QR_CODE_API_ROUTE + channelId);
    return await getApiActionResult(fetchPromise, true);
};

export const importChannelOperatorsAsync = async (sourceChannelId: number, targetChannelId: number, keepSourceOperators: boolean): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(
        IMPORT_CHANNEL_OPERATORS_API_ROUTE,
        {
            body: JSON.stringify({
                sourceChannelId,
                targetChannelId,
                keepSourceOperators,
            }),
        }
    );
    return await getApiActionResult(fetchPromise, false);
};